import React, {Component} from "react"
import { browserHistory, Link } from "react-router-dom"
import { Breadcrumb } from "semantic-ui-react"
import {observer} from "mobx-react"
import shop from "shop/shop"
import categoryStore from "stores/categoryStore"

@observer
class CollectionBreadcrumb extends Component{

  render(){
    let category = categoryStore.categoriesById.get(this.props.id)
    if(!category) return <div>keine Kategorie</div>
    let path = shop.getCategoryPath( this.props.id )
    let categoryTitle = ""
    if ( category && category.desc ) categoryTitle = category.desc.short_des
    return (<div className="">
      <Breadcrumb>
        <Breadcrumb.Section link as={Link} to="/">Home</Breadcrumb.Section>
        <Breadcrumb.Divider/>
        {path.length > 1 &&
        <Breadcrumb.Section link as={Link} style={{ whiteSpace: "nowrap" }} to={path[ 0 ].link}
                            className="parent-title">{path[ 0 ].title}</Breadcrumb.Section>}
        {path.length > 1 && <Breadcrumb.Divider/>}
        <Breadcrumb.Section active style={{ whiteSpace: "nowrap" }}>{categoryTitle}</Breadcrumb.Section>
      </Breadcrumb>
    </div>)
  }

}


export default CollectionBreadcrumb


// WEBPACK FOOTER //
// ./src/components/Collection/CollectionBreadcrumb.js